<template>
  <div class="modal-overlay">
    <div class="modal-content-small">
      <div class="modal-header">
        <div class="title-container">
          <h4 class="title">Add Holiday</h4>
        </div>
        <div class="modal-header-buttons">
          <button class="close-button" @click="closeModal">
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
      <div class="modal-body p-4">
        <div class="form-group mb-3">
          <label class="form-label">Select Date</label>
          <input type="date" class="form-control" v-model="form.date" />
        </div>
        <div class="form-group mb-3">
          <label class="form-label">Holiday Name</label>
          <input type="text" class="form-control" v-model="form.name" placeholder="Enter holiday name" />
        </div>
        <div class="form-group mb-4">
          <label class="form-label d-block mb-2">Holiday Type</label>
          <div class="row g-2">
            <div class="col-6">
              <label class="d-flex align-items-center gap-2 m-0 cursor-pointer">
                <input type="checkbox" value="public" v-model="form.types" /> Public
              </label>
            </div>
            <div class="col-6">
              <label class="d-flex align-items-center gap-2 m-0 cursor-pointer">
                <input type="checkbox" value="bank" v-model="form.types" /> Bank
              </label>
            </div>
            <div class="col-6">
              <label class="d-flex align-items-center gap-2 m-0 cursor-pointer">
                <input type="checkbox" value="mercantile" v-model="form.types" /> Mercantile
              </label>
            </div>
            <div class="col-6">
              <label class="d-flex align-items-center gap-2 m-0 cursor-pointer">
                <input type="checkbox" value="poya" v-model="form.types" /> Poya
              </label>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-4">
          <button class="btn btn-secondary" @click="closeModal" :disabled="isSaving">Cancel</button>
          <button class="btn btn-success" @click="saveHoliday" :disabled="isSaving">
            <span v-if="isSaving"><i class="fa fa-spinner fa-spin me-1"></i>Saving...</span>
            <span v-else>Save</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";
import { createHolidayData } from "../../services/dataService";

export default {
  name: 'AddHolidayModal',
  data() {
    return {
      isSaving: false,
      form: {
        date: '',
        name: '',
        types: []
      }
    };
  },
  mounted() {
    document.body.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.body.style.overflow = 'auto';
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    async saveHoliday() {
      const toast = useToast();

      // Front-end validations
      if (!this.form.date) {
        return toast.error("Please select a date.", { position: "top-right", timeout: 3000 });
      }
      if (!this.form.name || !this.form.name.trim()) {
        return toast.error("Please enter a holiday name.", { position: "top-right", timeout: 3000 });
      }
      if (this.form.types.length === 0) {
        return toast.error("Please select at least one holiday type.", { position: "top-right", timeout: 3000 });
      }

      this.isSaving = true;

      let year = null, month = null, day = null;
      if (this.form.date) {
        const parts = this.form.date.split('-');
        if (parts.length === 3) {
          year = parseInt(parts[0], 10);
          month = parseInt(parts[1], 10);
          day = parseInt(parts[2], 10);
        }
      }

      const profileId = parseInt(localStorage.getItem('profile_id'));

      const payload = {
        year: year,
        month: month,
        day: day,
        holiday: this.form.name,
        is_public: this.form.types.includes('public'),
        is_bank: this.form.types.includes('bank'),
        is_mercantile: this.form.types.includes('mercantile'),
        is_poya: this.form.types.includes('poya'),
        create_by: profileId,
        updated_by: profileId
      };

      try {
        const token = localStorage.getItem('token_set');
        const res = await createHolidayData(payload, token);
        
        if (res.data.status === 'success') {
          toast.success(res.data.message || 'Holiday created successfully.', { position: "top-right", timeout: 3000 });
          this.$emit('save', payload);
          this.closeModal();
        } else {
          throw new Error(res.data.message || 'Failed to create holiday.');
        }
      } catch (err) {
        console.error('Failed to create holiday:', err);
        const errorMsg = err.response?.data?.message || err.message || 'Failed to create holiday. Please try again.';
        toast.error(errorMsg, { position: "top-right", timeout: 3000 });
      } finally {
        this.isSaving = false;
      }
    }
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}
.modal-content-small {
  background-color: white;
  width: 100%;
  max-width: 450px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}
.modal-header {
  background-color: #5A6166;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}
.title {
  color: #fff;
  margin: 0;
  font-size: 1.1rem;
}
.close-button {
  background: none;
  border: none;
  color: white;
  font-size: 18px;
  cursor: pointer;
  padding: 0;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
